import { Action } from 'redux';
import { Customer } from 'src/types/model';

export interface CustomerState {
  loading: boolean;
  data: any;
  error: string | null;
}

export const FETCH_SETTING_REQUEST = 'FETCH_SETTING_REQUEST';
export const FETCH_SETTING_SUCCESS = 'FETCH_SETTING_SUCCESS';
export const FETCH_SETTING_FAILURE = 'FETCH_SETTING_FAILURE';

export interface FetchSettingRequestAction
  extends Action<typeof FETCH_SETTING_REQUEST> {}

export interface FetchSettingSuccessAction
  extends Action<typeof FETCH_SETTING_SUCCESS> {
  payload: Customer[];
}

export interface FetchSettingFailureAction
  extends Action<typeof FETCH_SETTING_FAILURE> {
  payload: string;
}

export type SettingActionType =
  | FetchSettingRequestAction
  | FetchSettingSuccessAction
  | FetchSettingFailureAction;
